import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

const names = ["House", "House1", "House2", "Apartment", "Mcdonald"];

const Building = ({ position, size, landId, landInfo, setLandName, setLandOwner, setHasOwner, setLandId }) => {

     const property = [<AdventureHouse/>, <StoneHouse/>, <Apartment />, <Mcdonald/>, <ModernHouse/>, <EmptyLand />];
     function clickHandler(){
      setLandName(landInfo.name)
      setLandId(landId)
      if (landInfo.owner === '0x0000000000000000000000000000000000000000') {
          setLandOwner('No Owner')
          setHasOwner(false)
      } else {
          setLandOwner(landInfo.owner)
          setHasOwner(true)
      }
    }
     
    return (
        <group position={position} scale={size} landId={landId} landInfo={landInfo} setLandName={setLandName} setLandOwner={setLandOwner} setHasOwner={setHasOwner} setLandId={setLandId} >{property[landId-1]}</group>
    );

    function AdventureHouse(props) {
      const group = useRef();
      const { nodes, materials } = useGLTF("/plant.glb");
      return (
        <group ref={group} {...props} dispose={null} onClick={clickHandler} >
              <group rotation={[-Math.PI / 2, 0, 0]}  >           
                  <mesh
                    castShadow
                    receiveShadow
                    geometry={nodes["House_Material_#149_0"].geometry}
                    material={nodes["House_Material_#149_0"].material}
                  />
                </group>
        </group>
      );
    }
    
       
     function StoneHouse(props) {
      const group = useRef();
      const { nodes, materials } = useGLTF("/house1-draco.glb");
      return (
        <group ref={group} {...props} dispose={null}  onClick={clickHandler} >
          <group rotation={[-Math.PI / 2, 0, 0]}>
            <group rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial.geometry}
                material={materials["09___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_1.geometry}
                material={materials["08___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_2.geometry}
                material={materials["07___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_3.geometry}
                material={materials["06___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_4.geometry}
                material={materials["04___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_5.geometry}
                material={materials["02___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_6.geometry}
                material={materials["01___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_7.geometry}
                material={materials.Material__30}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_8.geometry}
                material={materials["03___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_9.geometry}
                material={materials.Material__28}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_10.geometry}
                material={materials.Material__27}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_11.geometry}
                material={materials["10___Default"]}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.defaultMaterial_12.geometry}
                material={materials.Material__25}
              />
            </group>
          </group>
        </group>
      );
    }
    
     function Mcdonald(props) {
      const group = useRef();
      const { nodes, materials } = useGLTF("/mcdonald-draco.glb");
      return (
        <group ref={group} {...props} dispose={null}  onClick={clickHandler} >
          <group position={[0, -8.16, -3.28]} rotation={[Math.PI / 2,0 , Math.PI ]}>
            <group rotation={[-Math.PI, 0, 0]} >
              <group position={[0, -221.75, 241.68]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_WhiteLights_0.geometry}
                  material={materials.WhiteLights}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Windows_0.geometry}
                  material={materials.Windows}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Misc_0.geometry}
                  material={nodes.McDonalds_Misc_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Misc_0_1.geometry}
                  material={nodes.McDonalds_Misc_0_1.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Misc_0_2.geometry}
                  material={nodes.McDonalds_Misc_0_2.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Misc_0_3.geometry}
                  material={nodes.McDonalds_Misc_0_3.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_TubeLights_0.geometry}
                  material={nodes.McDonalds_TubeLights_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_TubeLights_0_1.geometry}
                  material={nodes.McDonalds_TubeLights_0_1.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_TubeLights_0_2.geometry}
                  material={nodes.McDonalds_TubeLights_0_2.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_TubeLights_0_3.geometry}
                  material={nodes.McDonalds_TubeLights_0_3.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_GreenSurface_0.geometry}
                  material={materials.GreenSurface}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Metal_0.geometry}
                  material={nodes.McDonalds_Metal_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Metal_0_1.geometry}
                  material={nodes.McDonalds_Metal_0_1.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Tiles_0.geometry}
                  material={materials.Tiles}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_YellowSurface_0.geometry}
                  material={nodes.McDonalds_YellowSurface_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_YellowSurface_0_1.geometry}
                  material={nodes.McDonalds_YellowSurface_0_1.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Door_0.geometry}
                  material={materials.Door}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Plaster_0.geometry}
                  material={materials.Plaster}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Sign_0.geometry}
                  material={nodes.McDonalds_Sign_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Sign_0_1.geometry}
                  material={nodes.McDonalds_Sign_0_1.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.McDonalds_Sign_0_2.geometry}
                  material={nodes.McDonalds_Sign_0_2.material}
                />
              </group>
            </group>
          </group>
        </group>
      );
    }
    
     function ModernHouse(props) {
      const group = useRef();
      const { nodes, materials } = useGLTF("/house2-draco.glb");
      return (
        <group ref={group} {...props} dispose={null}  onClick={clickHandler} >
         <group position={[0.04, 0, 0.04]} rotation={[-Math.PI / 2, 0, -1.5]}>
            <group rotation={[Math.PI / 2, 0, 0]}>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.Sphere_Area_Light_1200_Lumen_White_0.geometry}
                material={nodes.Sphere_Area_Light_1200_Lumen_White_0.material}
              />
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.Sphere_Area_Light_1200_Lumen_White_0_1.geometry}
                material={nodes.Sphere_Area_Light_1200_Lumen_White_0_1.material}
              />
              <group position={[3637.38, 275, 0]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Cladding_Paint_Matte_Grey_0.geometry}
                  material={nodes.Cladding_Paint_Matte_Grey_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Parter_Paint_Matte_Purple_0.geometry}
                  material={nodes.Parter_Paint_Matte_Purple_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box001_Matte_Black_#60_0"].geometry}
                  material={nodes["Box001_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box002_Matte_Black_#60_0"].geometry}
                  material={nodes["Box002_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box003_Matte_Black_#60_0"].geometry}
                  material={nodes["Box003_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box004_Matte_Black_#60_0"].geometry}
                  material={nodes["Box004_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box005_Matte_Black_#60_0"].geometry}
                  material={nodes["Box005_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box006_Matte_Black_#60_0"].geometry}
                  material={nodes["Box006_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box007_Matte_Black_#60_0"].geometry}
                  material={nodes["Box007_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box009_Wood_Dark_#3_0"].geometry}
                  material={nodes["Box009_Wood_Dark_#3_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box011_Paint_Matte_Grey_#1_0"].geometry}
                  material={nodes["Box011_Paint_Matte_Grey_#1_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Plane001_Cobblestone_0.geometry}
                  material={materials.Area_Light_1200_Lumen_White_0}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Box012_Paint_Matte_Purple_0.geometry}
                  material={nodes.Box012_Paint_Matte_Purple_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["StraightStair001_Wood_Dark_#3_0"].geometry}
                  material={nodes["StraightStair001_Wood_Dark_#3_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box013_Paint_Matte_Grey_#3_0"].geometry}
                  material={nodes["Box013_Paint_Matte_Grey_#3_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["StraightStair002_Wood_Dark_#3_0"].geometry}
                  material={nodes["StraightStair002_Wood_Dark_#3_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box014_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box014_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box018_Matte_Black_#60_0"].geometry}
                  material={nodes["Box018_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box021_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box021_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box022_Matte_Black_#60_0"].geometry}
                  material={nodes["Box022_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box023_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box023_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box024_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box024_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box025_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box025_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box026_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box026_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box027_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box027_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box028_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box028_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box029_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box029_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box030_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box030_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box031_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box031_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box032_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box032_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box033_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box033_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box034_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box034_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box035_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box035_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder001_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder001_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder002_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder002_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder003_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder003_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box036_Paint_Matte_Grey_#2_0"].geometry}
                  material={nodes["Box036_Paint_Matte_Grey_#2_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Parter001_Paint_Matte_Purple_0.geometry}
                  material={nodes.Parter001_Paint_Matte_Purple_0.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box037_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box037_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box038_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box038_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box039_Matte_Black_#60_0"].geometry}
                  material={nodes["Box039_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box040_Matte_Black_#60_0"].geometry}
                  material={nodes["Box040_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box041_Matte_Black_#60_0"].geometry}
                  material={nodes["Box041_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box042_Matte_Black_#60_0"].geometry}
                  material={nodes["Box042_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder004_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder004_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder005_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder005_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder006_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder006_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box043_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box043_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box044_Matte_Black_#60_0"].geometry}
                  material={nodes["Box044_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box045_Matte_Black_#60_0"].geometry}
                  material={nodes["Box045_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box046_Matte_Black_#60_0"].geometry}
                  material={nodes["Box046_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box047_Matte_Black_#60_0"].geometry}
                  material={nodes["Box047_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder007_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder007_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder008_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder008_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder009_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder009_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box048_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box048_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box049_Matte_Black_#60_0"].geometry}
                  material={nodes["Box049_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box050_Matte_Black_#60_0"].geometry}
                  material={nodes["Box050_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box051_Matte_Black_#60_0"].geometry}
                  material={nodes["Box051_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box052_Matte_Black_#60_0"].geometry}
                  material={nodes["Box052_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box054_Matte_Black_#60_0"].geometry}
                  material={nodes["Box054_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box055_Matte_Black_#60_0"].geometry}
                  material={nodes["Box055_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box056_Matte_Black_#60_0"].geometry}
                  material={nodes["Box056_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box057_Matte_Black_#60_0"].geometry}
                  material={nodes["Box057_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box059_Matte_Black_#60_0"].geometry}
                  material={nodes["Box059_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box060_Matte_Black_#60_0"].geometry}
                  material={nodes["Box060_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box061_Matte_Black_#60_0"].geometry}
                  material={nodes["Box061_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box062_Matte_Black_#60_0"].geometry}
                  material={nodes["Box062_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box064_Matte_Black_#60_0"].geometry}
                  material={nodes["Box064_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box065_Matte_Black_#60_0"].geometry}
                  material={nodes["Box065_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box066_Matte_Black_#60_0"].geometry}
                  material={nodes["Box066_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box067_Matte_Black_#60_0"].geometry}
                  material={nodes["Box067_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box069_Matte_Black_#60_0"].geometry}
                  material={nodes["Box069_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box070_Matte_Black_#60_0"].geometry}
                  material={nodes["Box070_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box071_Matte_Black_#60_0"].geometry}
                  material={nodes["Box071_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box072_Matte_Black_#60_0"].geometry}
                  material={nodes["Box072_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box073_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box073_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box074_Matte_Black_#60_0"].geometry}
                  material={nodes["Box074_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box075_Matte_Black_#60_0"].geometry}
                  material={nodes["Box075_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box076_Matte_Black_#60_0"].geometry}
                  material={nodes["Box076_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box077_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box077_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box078_Matte_Black_#60_0"].geometry}
                  material={nodes["Box078_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box079_Matte_Black_#60_0"].geometry}
                  material={nodes["Box079_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box080_Matte_Black_#60_0"].geometry}
                  material={nodes["Box080_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box081_Matte_Black_#60_0"].geometry}
                  material={nodes["Box081_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder010_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder010_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box082_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box082_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder011_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder011_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box083_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box083_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder012_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder012_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder013_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder013_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box084_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box084_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box085_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box085_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder014_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder014_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder015_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder015_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box087_Matte_Black_#60_0"].geometry}
                  material={nodes["Box087_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box088_Matte_Black_#60_0"].geometry}
                  material={nodes["Box088_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box089_Matte_Black_#60_0"].geometry}
                  material={nodes["Box089_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box090_Matte_Black_#60_0"].geometry}
                  material={nodes["Box090_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder016_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder016_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder017_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder017_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder018_Steel_Polished_#13_0"].geometry}
                  material={nodes["Cylinder018_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder019_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder019_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder020_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder020_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Cylinder021_Matte_Black_#60_0"].geometry}
                  material={nodes["Cylinder021_Matte_Black_#60_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box091_Wood_Dark_#3_0"].geometry}
                  material={nodes["Box091_Wood_Dark_#3_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box092_Steel_Polished_#13_0"].geometry}
                  material={nodes["Box092_Steel_Polished_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box093_Acaia_Dark_#15_0"].geometry}
                  material={nodes["Box093_Acaia_Dark_#15_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box094_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box094_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box095_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box095_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box098_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box098_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box099_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box099_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box100_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box100_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box101_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box101_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box102_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box102_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box103_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box103_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box104_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box104_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box105_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box105_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box106_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box106_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box107_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box107_Paint_Matte_Black_#13_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box108_Glass_Basic_White_#14_0"].geometry}
                  material={nodes["Box108_Glass_Basic_White_#14_0"].material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes["Box109_Paint_Matte_Black_#13_0"].geometry}
                  material={nodes["Box109_Paint_Matte_Black_#13_0"].material}
                />
              </group>
              <group position={[2365.06, 5832.26, -4920.06]} scale={331.44}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Sphere_Area_Light_1200_Lumen_White_0_2.geometry}
                  material={nodes.Sphere_Area_Light_1200_Lumen_White_0_2.material}
                />
              </group>
            </group>
          </group>
        </group>
      );
    }
    
    
    function Apartment(props) {
      const group = useRef();
      const { nodes, materials } = useGLTF("/house3-draco.glb");
      return (
        <group ref={group} {...props} dispose={null}  onClick={clickHandler} >
        <group rotation={[-Math.PI / 2, 0, Math.PI / 2]}>
          <group rotation={[Math.PI / 2, 0, 0]}>
            <group rotation={[Math.PI / 2, 0, 0]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_4.geometry}
                  material={materials.FrontColor}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_8.geometry}
                  material={materials.WindowOP}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_9.geometry}
                  material={materials.MatMetalPArts}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_7.geometry}
                  material={materials.RoofingGen}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_10.geometry}
                  material={materials.MAtClayBAsement}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_5.geometry}
                  material={materials.BricksRedGen}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_13.geometry}
                  material={materials.Material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_12.geometry}
                  material={materials.WoodSticks}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_6.geometry}
                  material={nodes.Object_6.material}
                />
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_11.geometry}
                  material={materials.MatMetalWorks}
                />
              </group>
              <group rotation={[Math.PI / 2, 0, 0]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_15.geometry}
                  material={nodes.Object_15.material}
                />
              </group>
              <group rotation={[Math.PI / 2, 0, 0]}>
                <mesh
                  castShadow
                  receiveShadow
                  geometry={nodes.Object_17.geometry}
                  material={nodes.Object_17.material}
                />
              </group>
              <mesh
                castShadow
                receiveShadow
                geometry={nodes.Object_19.geometry}
                material={materials.Pavement}
              />
            </group>
          </group>
        </group>
      );
    }
    
    
    function EmptyLand(props) {
      return (
          <mesh {...props} rotation={[-Math.PI/2, 0, 0]}  /*onClick={clickHandler}*/ >
                <planeBufferGeometry attach="geometry" />
                <meshStandardMaterial color={'brown'} metalness={0.5} roughness={0} />
            </mesh>
      );
    }
}


export default Building;